<template>
  <div id="status-list">
    <div v-if="error">
      <p class="has-text-danger">{{ $t("status.text_api_err") }}</p>
    </div>
    <div v-else>
      <div v-if="loading">
        <p class="has-text-info">{{ $t("status.text_loading") }}</p>
      </div>

      <div v-else>
        <div v-if="$i18n.locale == 'fr'">
          <ul
            class="service-list"
            v-for="component in infoFr"
            :key="component.id"
          >
            <li>
              <div
                class="has-text-danger"
                v-if="component.state === 'degraded'"
              >
                <font-awesome-icon :icon="['fas', 'times-circle']" />
                {{ component.name }} {{ $t("status.text_danger") }}
              </div>
              <div
                class="has-text-warning"
                v-else-if="component.state === 'partially-degraded'"
              >
                <font-awesome-icon :icon="['fas', 'times-circle']" />
                {{ component.name }} {{ $t("status.text_warning") }}
              </div>
              <div
                class="has-text-success"
                v-else-if="component.state === 'operational'"
              >
                <font-awesome-icon :icon="['fas', 'check-circle']" />
                {{ component.name }} {{ $t("status.text_success") }}
              </div>
              <div class="has-text-info" v-else>
                <font-awesome-icon :icon="['fas', 'times-circle']" />
                {{ component.name }} - {{ $t("status.text_err") }}
              </div>
            </li>
          </ul>
        </div>
        <div v-else>
          <ul
            class="service-list"
            v-for="component in info"
            :key="component.id"
          >
            <li>
              <div
                class="has-text-danger"
                v-if="component.state === 'degraded'"
              >
                <font-awesome-icon :icon="['fas', 'times-circle']" />
                {{ component.name }} {{ $t("status.text_danger") }}
              </div>
              <div
                class="has-text-warning"
                v-else-if="component.state === 'partially-degraded'"
              >
                <font-awesome-icon :icon="['fas', 'times-circle']" />
                {{ component.name }} {{ $t("status.text_warning") }}
              </div>
              <div
                class="has-text-success"
                v-else-if="component.state === 'operational'"
              >
                <font-awesome-icon :icon="['fas', 'check-circle']" />
                {{ component.name }} {{ $t("status.text_success") }}
              </div>
              <div class="has-text-info" v-else>
                <font-awesome-icon :icon="['fas', 'times-circle']" />
                {{ component.name }} - {{ $t("status.text_err") }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/services/API";
import ApiFr from "@/services/API_FR";
export default {
  name: "StatusMessage",
  data() {
    return {
      info: null,
      infoFr: null,
      loading: true,
      error: "",
      errored: false
    };
  },
  mounted() {
    this.getComponentDetails();
    this.getComponentDetailsFr();
  },

  methods: {
    getComponentDetailsFr() {
      return ApiFr()
        .get("/components")

        .then(response => (this.infoFr = response.data.response))

        .catch(error => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },

    getComponentDetails() {
      return Api()
        .get("/components")
        .then(response => (this.info = response.data.response))
        .catch(error => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style lang="scss">
.service-list li {
  padding-left: 0px;
  list-style: none;
}
</style>
